import BookItem from "../common/bookItem";
import AppRenderer from "../../app_renderer";
import BookData from "../../book_data";
import EventBus from "../../event_bus";
import { mouseEvent } from "../common/mouse_event";
import { OUT_OPEN_TYPE } from "../common/bookItemDefine";
import Visibility from "../common/visibility";
import SystemData from "../../system_data";

//等待中
export default class OutOpenHtml extends BookItem {
    OutOpenType = OUT_OPEN_TYPE.HTML;
    /**
     *
     * @type {Visibility}
     * @memberof JumpPage
     */
    visibilityComponent = null;
    constructor(el, target) {
        super(el, target);
        this.path = this.el.path;
        this.connectNumber = this.el.connectNumber;
        this.inBbook = this.el.inBbook;
        this.add_mouse_event();

    }
    
    init() {
        this.target.gotoAndStop(0);//初始化影格
        this.target.visible = false;
        console.log(`init visible set ${this.target.visible}`);
        mouseEvent.add_mouse_event(this);
        this.visibilityComponent = new Visibility(this.target, this, this.itemControl);
        this.itemControl.loader.singleAntialiasing(this.target);
    }

    start() {
        this.visibilityComponent.setVisibleByGroup();
    }

    trigger() {
        self = this;
        console.log("外開html網址::", self.path);

        if (!self.inBbook) {
            // TIP : HTML外開
            if (self.path.indexOf("html") != -1 && self.path.indexOf("http") == -1) {
                if (SystemData.Instance.getPlatform() == 'darwin'){
                    let path = BookData.Instance.getBookPath() + self.path;
                    let newPath = SystemData.Instance.changePathToMac(path);
                    AppRenderer.Instance.openFile(newPath);
                }else{
                    AppRenderer.Instance.openFile(BookData.Instance.getBookPath() + self.path);
                }
            } else {
                console.error("外開html僅支援書本內html檔案")
            }
        }
        else {
            // TIP : HTML內遷
            EventBus.getInstance().getAppRefs().iframeContainer.openUrl(BookData.Instance.getBookPath() + self.path);
        }

    }

    add_mouse_event() {
        this.target.mouseChildren = false;
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
        });
    }
}